<main [@fadeInOut] id="main-heading" role="main" tabindex="0" [@fadeInOut]>
  <div class="container-fluid">
    <div class="d-flex flex-column main-heading-div">
      <div class="mx-5 ps-4 pb-3 text-decoration-none">
        <a class="pointer text-decoration-none" href="javascript:void(0);" (click)="returnToList()">
          <i class="fal fa-caret-left"></i> Return to Submission History
        </a>
      </div>

      <div class="ms-5 pe-5 ps-4">
        <div class="col-sm-3 my-2 ps-1 me-3 align-self-end">
          <h1>{{headerVar}} Details</h1>
        </div>
        <div class="flex-grow-1 my-2 text-end accordion-links align-self-end">
          <a href='javascript:void(0)' (click)="collapseAll()">Collapse All </a> |
          <a href='javascript:void(0)' (click)="expandAll()">Expand All </a>
        </div>
      </div>

      <div class="ms-5 ps-4 me-5">
        <div class="flex-row">

          <div class="d-flex" *ngIf="itemType === 'device'">
            <div class="col-sm-2 top-space panel-sticky">
              <div class="card card-primary form-panel fixed me-2">
                <div class="card-header bg-primary text-white">Identification</div>
                <div class="card-body">
                  <table class="table table-condensed">
                    <ng-container *ngIf="showLegacy; then legacyDeviceTemplate else regulationDeviceTemplate">
                    </ng-container>
                    <ng-template #legacyDeviceTemplate>
                      <tbody>
                        <tr>
                          <th>EUDAMED ID</th>
                        </tr>
                        <tr>
                          <td>
                            <span class="breakAll">{{eudamedId}}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>{{headerVar}} Revision Number</th>
                        </tr>
                        <tr>
                          <td>
                            <span>{{revision}}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>EUDAMED ID Issuing Agency</th>
                        </tr>
                        <tr>
                          <td> <span>{{eudamedIdIssuingAgency}}</span></td>
                        </tr>
                        <tr>
                          <th>Product SKU</th>
                        </tr>
                        <tr>
                          <td [ngClass]="isDefault('Product SKU')">
                            <span class="breakAll">{{productSKU}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </ng-template>
                    <ng-template #regulationDeviceTemplate>
                      <tbody>
                        <tr>
                          <th>Primary Device Identifier (DI)</th>
                        </tr>
                        <tr>
                          <td [ngClass]="isDefault('Primary DI')">
                            <span class="breakAll">{{udiDI}}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>{{headerVar}} Revision Number</th>
                        </tr>
                        <tr>
                          <td [ngClass]="isDefault('Revision Number')">
                            <span>{{revision}}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>Primary DI Issuing Agency</th>
                        </tr>
                        <tr>
                          <td [ngClass]="isDefault('Primary DI Issuing Agency')"> <span>{{agency}}</span></td>
                        </tr>

                        <tr>
                          <th>Product SKU</th>
                        </tr>
                        <tr>
                          <td [ngClass]="isDefault('Product SKU')">
                            <span>{{productSKU}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </ng-template>

                  </table>
                </div>
              </div>
            </div>

            <div class="flex-grow-1 top-space">
              <ejs-accordion #properties expandMode='Mulitple' (created)='accordionCreated($event)'>
                <e-accordionitems>
                  <e-accordionitem header='Identification and Classification' [content]='identificationclassificationSK'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.SKOREA.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Identification and Classification' [content]='identificationclassificationCH'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.CHINA.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Identification and Classification' [content]='identificationclassificationEU'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SWISSDAMED.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Identification and Classification' [content]='identificationclassificationUS'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.BRAZIL.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Device Characteristics' [content]='devicecharacteristicsEU'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SWISSDAMED.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Device Characteristics' [content]='devicecharacteristics'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.CHINA.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SKOREA.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Device Characteristics' [content]='devicecharacteristicsUS'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.BRAZIL.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Packaging' [content]='packaging' *ngIf="showDevicePackagingSection()">
                  </e-accordionitem>
                  <e-accordionitem header='Device Status and Marketing Information' [content]='devicemarketingEU'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SWISSDAMED.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Device Status and Marketing Information' [content]='devicemarketing'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.CHINA.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SKOREA.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Device Status and Marketing Information' [content]='devicemarketingUS'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.BRAZIL.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Device Registration and UDI Database Publication Information'
                    [content]='deviceregistration'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.CHINA.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SKOREA.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.AU.toLowerCase()|| dataScope.toLowerCase() === dataScopesEnum.BRAZIL.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Containing Substances and Critical Warnings or Contraindications'
                    [content]='substanceswarningsEU'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SWISSDAMED.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Containing Substances and Critical Warnings or Contraindications'
                    [content]='substanceswarnings'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.CHINA.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SKOREA.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header='Containing Substances and Critical Warnings or Contraindications'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.BRAZIL.toLowerCase()"
                    [content]='substanceswarningsUS'>
                  </e-accordionitem>
                  <e-accordionitem header='Product Designer' [content]='productdesignerEU'
                    *ngIf="(dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SWISSDAMED.toLowerCase()) && !sppDevice">
                  </e-accordionitem>
                </e-accordionitems>
              </ejs-accordion>
            </div>

          </div>
          <div class="d-flex" *ngIf="itemType === 'model'">
          <div class="col-sm-2 top-space panel-sticky">
              <div class="card card-primary form-panel fixed me-2">
                <div class="card-header bg-primary text-white">Identification</div>
                <div class="card-body">
                  <table class="table table-condensed">

                    <ng-container *ngIf="showLegacy; then legacyModelTemplate else regulationModelTemplate">
                    </ng-container>
                    <ng-template #legacyModelTemplate>
                      <tbody>
                        <tr>
                          <th>EUDAMED DI</th>
                        </tr>
                        <tr>
                          <td> <span class="breakAll">{{eudamedDi}}</span></td>
                        </tr>
                        <tr>
                          <th>EUDAMED DI Issuing Agency</th>
                        </tr>
                        <tr>
                          <td> <span>{{eudamedDiIssuingAgency}}</span></td>
                        </tr>
                        <tr>
                          <th>{{headerVar}} Revision Number</th>
                        </tr>
                        <tr>
                          <td>
                            <span>{{revision}}</span>
                          </td>
                        </tr>                        
                      </tbody>
                    </ng-template>
                    <ng-template #regulationModelTemplate>
                      <tbody>
                        <tr>
                          <th>Basic UDI-DI Number (BUDI-DI)</th>
                        </tr>
                        <tr>
                          <td [ngClass]="isDefault('Basic UDI-DI')"> <span class="breakAll">{{budi}}</span></td>
                        </tr>
                        <tr>
                          <th>Issuing Agency</th>
                        </tr>
                        <tr>
                          <td [ngClass]="isDefault('Basic UDI-DI')"> <span>{{modelAgency}}</span></td>
                        </tr>
                        <tr>
                          <th>{{headerVar}} Revision Number</th>
                        </tr>
                        <tr>
                          <td [ngClass]="isDefault('Revision Number')">
                            <span>{{revision}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </ng-template>
                  </table>
                </div>
              </div>
            </div>

            <div class="flex-grow-1 top-space">

              <ejs-accordion #properties expandMode='Mulitple' (created)='accordionCreated($event)'>

                <e-accordionitems>
                  <e-accordionitem header=' Identification and Classification '
                    [content]='modelidentificationclassificationEU'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SWISSDAMED.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem header=' Model or Device Group Characteristics  ' [content]='groupcharacteristicsEU'
                    *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SWISSDAMED.toLowerCase()">
                  </e-accordionitem>
                  <e-accordionitem [header]='getModelClinicalInvestigationHeader()'
                    [content]='clinicalinvestigationEU'
                    *ngIf="showModelClinicalInvestigationSection()">
                  </e-accordionitem>
                </e-accordionitems>
              </ejs-accordion>
              <!--</div>-->
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<div class="bottom-padding"></div>

<!--Model Accordion sections-->
<ng-template #modelidentificationclassificationEU let-data>
  <app-submission-model-indentification-classification-eu [itemData]='itemData' [mapArray]='mapArray' [showLegacy]='showLegacy'
    [readOnly]='readOnly' [sppModel]='sppModel'>
  </app-submission-model-indentification-classification-eu>
</ng-template>

<ng-template #groupcharacteristicsEU let-data>
  <app-submission-model-group-characteristics-eu [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'
    [sppModel]='sppModel'>
  </app-submission-model-group-characteristics-eu>
</ng-template>

<ng-template #clinicalinvestigationEU let-data>
  <app-submission-model-clinical-investigation-eu [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-submission-model-clinical-investigation-eu>
</ng-template>

<!-- Device Accordion sections-->
<ng-template #identificationclassificationSK let-data>
  <app-submission-identity-classification-sk [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-submission-identity-classification-sk>
</ng-template>

<ng-template #identificationclassificationCH>
  <app-submission-identity-classification-ch [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-submission-identity-classification-ch>
</ng-template>

<ng-template #identificationclassificationEU>
  <app-submission-indentification-classification-eu [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'  [showLegacy]='showLegacy'
    [sppDevice]='sppDevice' [applicableRegulation]='applicableRegulation'>
  </app-submission-indentification-classification-eu>
</ng-template>

<ng-template #identificationclassificationUS let-data>
  <app-submission-identification-classification-us [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-submission-identification-classification-us>
</ng-template>

<ng-template #devicecharacteristicsEU let-data>
  <app-submission-device-characteristics-eu [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'
    [sppDevice]='sppDevice' [applicableRegulation]='applicableRegulation'>
  </app-submission-device-characteristics-eu>
</ng-template>

<ng-template #devicecharacteristics let-data>
  <app-submission-device-characteristics [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-submission-device-characteristics>
</ng-template>

<ng-template #devicecharacteristicsUS let-data>
  <app-submission-device-characteristics-us [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-submission-device-characteristics-us>
</ng-template>

<ng-template #packaging let-data>
  <app-submission-device-packaging [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'
    [sppDevice]='sppDevice'>
  </app-submission-device-packaging>
</ng-template>

<ng-template #devicemarketing let-data>
  <app-submission-device-marketing [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-submission-device-marketing>
</ng-template>

<ng-template #devicemarketingEU let-data>
  <app-submission-device-marketing-eu [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'
    [sppDevice]='sppDevice' [applicableRegulation]='applicableRegulation'>
  </app-submission-device-marketing-eu>
</ng-template>

<ng-template #devicemarketingUS let-data>
  <app-submission-device-marketing-us [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'
    [sppDevice]='sppDevice'>
  </app-submission-device-marketing-us>
</ng-template>

<ng-template #deviceregistration let-data>
  <app-submission-device-registration [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'
    [sppDevice]='sppDevice'>
  </app-submission-device-registration>
</ng-template>

<ng-template #substanceswarningsEU let-data>
  <app-submission-device-substances-warnings-eu [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'
    [sppDevice]='sppDevice' [applicableRegulation]='applicableRegulation'>
  </app-submission-device-substances-warnings-eu>
</ng-template>

<ng-template #substanceswarnings let-data>
  <app-submission-substances-warnings [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'
    [sppDevice]='sppDevice'>
  </app-submission-substances-warnings>
</ng-template>

<ng-template #substanceswarningsUS let-data>
  <app-submission-device-substance-warnings-us [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'
    [sppDevice]='sppDevice'>
  </app-submission-device-substance-warnings-us>
</ng-template>

<ng-template #productdesignerEU let-data>
  <app-submission-device-product-designer-eu [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'
    [sppDevice]='sppDevice'>
  </app-submission-device-product-designer-eu>
</ng-template>
